export const TriStateCheckboxesFlow = {
  DEFUALT: 0,
  ALTERNATIVE_CHECKBOXES: 1
}
